// Free tier: can this talent take money right now?
//
// The server decides (lib/talentMoney.js) and sends `canTakeMoney` with every
// profile, the fan page's and the talent's own. False = no bank connected yet,
// or not approved yet: the talent receives FREE requests only, so every way to
// pay them is hidden from fans, and the talent's own money buttons open
// "Connect your bank".
//
// Only an explicit `false` counts. A profile that doesn't carry the field (a
// cached copy, an older server) behaves exactly as it always has.
export function takesMoney(dj?: { canTakeMoney?: boolean } | null): boolean {
  return dj?.canTakeMoney !== false;
}
